import { Box, Stack } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';
import React from 'react';
import useBundleTranslation from 'i18n';

interface IProps {
    message: string;
}

function InvalidRequestPart({ message }: IProps) {
    const { t } = useBundleTranslation(['app/concierge/widget']);

    return (
        <Box
            sx={{
                padding: 1,
            }}
        >
            <Stack direction="row" spacing={2} alignItems="flex-start">
                <IconMi
                    icon="error"
                    sx={{
                        fontSize: '24px',
                        color: 'error.main',
                        flexShrink: 0,
                    }}
                />
                <Box sx={{ flex: 1 }}>
                    <Box
                        sx={{
                            fontWeight: 600,
                            fontSize: '14px',
                            color: 'error.main',
                            marginBottom: '8px',
                        }}
                    >
                        {t('error.invalid_request')}
                    </Box>
                    <Box
                        sx={{
                            fontSize: '13px',
                            color: 'text.primary',
                            lineHeight: 1.5,
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {message}
                    </Box>
                </Box>
            </Stack>
        </Box>
    );
}

export default InvalidRequestPart;
